import type { AxiosInstance, AxiosPromise } from 'axios';
import type { HotOffersResponse } from './types';

export default function hotOffers(http: AxiosInstance) {
  return {
    countries({
      departure,
    }: {
      departure: string[];
    }): AxiosPromise<HotOffersResponse> {
      return http.get(`hot-offers/countries?departure=${departure.join(',')}`);
    },
    cities({
      origCity,
      destCountry,
    }: {
      origCity: string;
      destCountry: string;
    }): AxiosPromise<HotOffersResponse> {
      return http.get(
        `hot-offers/cities?orig_city=${origCity}&dest_country=${destCountry}`,
      );
    },
    route({
      origCity,
      destCity,
    }: {
      origCity: string;
      destCity: string;
    }): AxiosPromise<HotOffersResponse> {
      return http.get(
        `hot-offers/route?orig_city=${origCity}&dest_city=${destCity}`,
      );
    },
  };
}
